import React from 'react';
import './UserAvatar.css';

const getInitials = (user) => {
    const givenInitial = user?.givenName?.charAt(0)?.toUpperCase() || '';
    const familyInitial = user?.familyName?.charAt(0)?.toUpperCase() || '';

    if (givenInitial || familyInitial) {
        return `${givenInitial}${familyInitial}`;
    }

    const fallback = user?.name || user?.userId || '?';
    return fallback.charAt(0).toUpperCase();
};

const UserAvatar = ({ user, size = 40, className = '' }) => {
    const name = user?.name || user?.userId || '?';
    const initials = getInitials(user);
    const avatarUrl = user?.avatarUrl;

    const style = {
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${size * 0.4}px`,
    };

    return (
        <div className={`user-avatar ${className}`.trim()} style={style}>
            {avatarUrl ? (
                <img src={avatarUrl} alt={name} />
            ) : (
                <div className="avatar-placeholder-generic">
                    {initials}
                </div>
            )}
        </div>
    );
};

export default UserAvatar;
